// todo(Gustav): should we have a panel? it is there in the prototype and

import { ExpandToggleIcon } from "@simplex/sx-icons";

// I think it makes it easier to find things in the code
export const Panel = (props: {
  children?: React.ReactNode;
  id?: string;
  label?: React.ReactNode;
  secondaryLabel?: React.ReactNode;
  toggle?: () => void;
  isFullscreen?: boolean;
}) => {
  return (
    <div
      id={props.id}
      className="sx-viewport-panel"
      style={{
        width: "100%",
        height: "100%",
        padding: "12px",
      }}
    >
      <div
        className="sx-viewport-label"
        style={{
          width: "100%",
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            minWidth: 0,
            flex: 1,
            paddingRight: props.toggle ? "20px" : "0",
          }}
        >
          <span>{props.label}</span>

          {props.secondaryLabel && (
            <span
              style={{
                color: "var(--text-muted, #808080)",
                fontSize: "0.78rem",
                whiteSpace: "nowrap",
              }}
            >
              {props.secondaryLabel}
            </span>
          )}
        </div>

        {props.toggle && (
          <button
            onClick={props.toggle}
            style={{
              position: "absolute",
              right: "6px",
              top: "3px",
              background: "transparent",
              border: "none",
            }}
          >
            <ExpandToggleIcon color="#727272" size={16} strokeWidth={2} expanded={props.isFullscreen ?? false} />
          </button>
        )}
      </div>

      {props.children}
    </div>
  );
};
